export default {
    storeIntegrationProcess:    { method: 'post',   url: 'integration_hours' },
    updateIntegrationProcess:   { method: 'put',    url: 'integration_hours/{id}'},
    destroyIntegrationProcess:  { method: 'delete', url: 'integration_hours/{id}'},
    runIntegrationProcess:      { method: 'post', url: 'integrations/run/{id}'},
    indexIntegrationProcess:    { method: 'get', url: 'integration-process/items/{id}'},
    findIntegrationProcess:     { method: 'get', url: 'integration-process/{id}'},
    getReponseProcess:          { method: 'get', url: 'integration-process/response/{id}'}
}